import { getServerUrl } from '@app/dashboard/utils/serverUrls';

export const PAYME_BASE_URL = `${getServerUrl()}/payme`;